// extracted by mini-css-extract-plugin
module.exports = {"container":"FascistBoard_container__1wctv","image":"FascistBoard_image__2urjH","rule":"FascistBoard_rule__3c0s3"};